module.exports = "<div class=\"margin-top-24 text-align-center\" [ngStyle]=\"{'color': color}\">\n  Version: {{ ENV.APPVERSION }}-{{ ENV.ENV }}\n</div>\n"